import React from 'react';
import '../../../scss/containers/trusted-by.scss';

export const TrustedSection = ({
  title = 'Trusted by Thousands',
  subtitle = 'Over 1B Site Previews!',
  bgColor = 'bg-white',
  logos = [
    { src: '/oku-logo.avif', alt: 'Client Logo 1' },
    { src: '/mocha.svg', alt: 'Client Logo 2' },
    { src: '/plugmob.svg', alt: 'Client Logo 3' },
    { src: '/mozilla.svg', alt: 'Client Logo 4' },
    { src: '/xfinity.svg', alt: 'Client Logo 5' }
  ]
}) => {
  return (
    <section className="trusted-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{title}</h2>
          <p className="section-subtitle">{subtitle}</p>
        </div>

        <div className="trust-logos">
          {logos.map((logo, index) => (
            <div key={index} className="trust-logo">
              <img
                src={logo.src}
                alt={logo.alt}
                className="max-h-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}; 